(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pnp-casino/assets/javascripts/category-page-pnp.js') >= 0) return;  svs.modules.push('/modules/pnp-casino/assets/javascripts/category-page-pnp.js');
"use strict";


class PnpCategoryPage {
  constructor() {
    var _svs$pnp_casino$data, _svs$pnp_casino$data2;
    if (svs.core.detect.formfactor.mobile() && !((_svs$pnp_casino$data = svs.pnp_casino.data) !== null && _svs$pnp_casino$data !== void 0 && (_svs$pnp_casino$data = _svs$pnp_casino$data.renderModel) !== null && _svs$pnp_casino$data !== void 0 && _svs$pnp_casino$data.gameCacheEmpty)) {
      new svs.casino.quick_transaction.TransactionButtons();
    }
    this.categories = svs.pnp_casino.data.categories;
    this.currentCategory = svs.pnp_casino.data.currentCategory;
    this.gamePromoViews = [];
    this.gamelistEl = document.querySelector('.js-pnp-category-list .casino-game-list');
    this.widgetWrapper = document.querySelector('.js-category-widget-wrapper');
    this.log = new svs.core.log.Logger('pnp:category-page');
    const options = {
      el: 'js-items-menu-wrapper',
      useScrollHelpers: !svs.core.detect.formfactor.mobile(),
      useScrollFaders: true,
      scrollToSelected: true,
      showScrollbar: false,
      clickCallback: this.onItemClick.bind(this)
    };
    if (!((_svs$pnp_casino$data2 = svs.pnp_casino.data) !== null && _svs$pnp_casino$data2 !== void 0 && (_svs$pnp_casino$data2 = _svs$pnp_casino$data2.renderModel) !== null && _svs$pnp_casino$data2 !== void 0 && _svs$pnp_casino$data2.gameCacheEmpty)) {
      new svs.ui.ItemsMenu(options);
    }
    this.router = new svs.components.casino.Router(svs.core.data.routes);
    this.initGameCache();
    this.gameList = new svs.components.casino.GameList(svs.pnp_casino.data.gameList, false);
    svs.components.casino.animateHeader.init();
  }
  onItemClick(node) {
    const title = node['data-title'];
    const urlPath = node['data-url-path'];
    this.trackEvent(title);
    if (title === this.currentCategory.title) {
      return false;
    }
    this.changeCategory(this.categories.find(cat => cat.title === title));
    const currentCategory = this.currentCategory;
    this.router.navigate(urlPath, true, null, {
      title: currentCategory.metaTitle,
      description: currentCategory.metaDescription
    });
  }
  trackEvent(title) {
    if (title) {
      const eventData = {
        category: 'Casino',
        event: 'click',
        action: 'Categories',
        opt_label: title
      };
      svs.components.analytics.trackEvent(eventData);
    }
  }
  async changeCategory(category) {
    const gameListEl = this.gamelistEl.querySelector('.casino-game-list-row');
    gameListEl.classList.add('casino-game-list-row-hide');
    this.loader = null;
    const loaderTimeout = setTimeout(() => {
      this.loader = new svs.ui.Loader('.js-pnp-category-list .casino-game-list');
      this.loader.show(300);
    }, 220);
    this.currentCategory = category;
    this.gameList.updateLabel('Sortera');
    this.gameList && this.gameList.destroy();
    const {
      games,
      totalCount
    } = await this.fetchCategoryGames(category.listId);
    clearTimeout(loaderTimeout);
    this.loader && this.loader.hide();
    this.renderGames(games);
    this.gamelistEl.querySelector('.js-casino-game-list-totalcount').innerHTML = totalCount;
    gameListEl.classList.remove('casino-game-list-row-hide');

    svs.core.widget_area.loadArea(this.currentCategory.selectedWidgetArea, safeString => {
      var _safeString$string;
      const widget = (_safeString$string = safeString === null || safeString === void 0 ? void 0 : safeString.string) !== null && _safeString$string !== void 0 ? _safeString$string : '';
      this.widgetWrapper.innerHTML = widget;
    });
  }
  async fetchCategoryGames(listId) {
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
    if (useLegacyJupiterApi) {
      try {
        const res = await svs.core.jupiterFetch.get("content/2/listfilter?listId=".concat(listId, "&onlyName=true&routesDomain=spela&count=5000&channel=").concat(svs.core.data.capabilities.channel));
        const jsonRes = await res.json();
        if (jsonRes.result) {
          return {
            games: jsonRes.result,
            totalCount: jsonRes.totalCount
          };
        }
        return [];
      } catch (e) {
        this.log.error('Error fetching games for category', e);
        this.loader && this.loader.hide();
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          icon: 'time-limit',
          branding: svs.ui.dialog.branding.SPORT,
          type: svs.ui.dialog.type.ERROR,
          title: 'Något gick fel!',
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: 'Det gick tyvärr inte att hämta spelen i vald kategori. Var god försök igen vid ett senare tillfälle.'
          }],
          actions: [{
            title: 'Okej'
          }]
        }));
        return [];
      }
    }

    try {
      const client = svs.content.shared.getCmsClient();
      const response = await client.v1.content.listFilter({
        listIds: listId,
        count: 5000,
        include: 'name',
        channels: svs.core.data.capabilities.channel
      });
      return {
        games: response.result,
        totalCount: response.totalCount
      };
    } catch (e) {
      this.log.error('Error fetching games for category (CMS API)', e);
      this.loader && this.loader.hide();
      svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
        icon: 'time-limit',
        branding: svs.ui.dialog.branding.SPORT,
        type: svs.ui.dialog.type.ERROR,
        title: 'Något gick fel!',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: 'Det gick tyvärr inte att hämta spelen i vald kategori. Var god försök igen vid ett senare tillfälle.'
        }],
        actions: [{
          title: 'Okej'
        }]
      }));
      return [];
    }
  }
  renderGames(games) {
    const fragment = new DocumentFragment();
    const appendTo = this.gamelistEl.querySelector('.casino-game-list-row');
    const gameModels = games.map(game => svs.components.casino.data.gameCache.index[game.name]);
    gameModels.forEach(game => {
      const li = document.createElement('li');
      li.classList.add('casino-game-list-item', 'col-xs-6', 'col-md-4', 'col-am-4', 'col-lg-3', 'padding-xs-right-1', 'padding-xs-bottom-1', 'padding-md-right-2', 'padding-md-bottom-2');
      li.innerHTML = svs.casino.game.templates.promo(game);
      fragment.appendChild(li);
    });
    appendTo.innerHTML = '';
    appendTo.appendChild(fragment);
    this.gameList = new svs.components.casino.GameList($(this.gamelistEl), false);
  }
  initGameCache() {
    const gameList = [];
    for (const gameName of Object.keys(svs.components.casino.data.gameCache.index)) {
      gameList.push(svs.components.casino.data.gameCache.index[gameName]);
    }
    svs.components.casino.game.extendCache(gameList);
  }
}
setGlobal('svs.pnp_casino.initPnpCategoryPage', () => new PnpCategoryPage());

 })(window);